import { render, staticRenderFns } from "./TemplatePreview.vue?vue&type=template&id=5b3d6506&scoped=true"
import script from "./TemplatePreview.vue?vue&type=script&lang=ts"
export * from "./TemplatePreview.vue?vue&type=script&lang=ts"
import style0 from "./TemplatePreview.vue?vue&type=style&index=0&id=5b3d6506&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3d6506",
  null
  
)

export default component.exports